// src/analytics/Analytics.tsx
import {useEffect} from "react";
import {useLocation} from "react-router-dom";

declare global {
    interface Window {
        dataLayer: any[];
        gtag: (...args: any[]) => void;
    }
}

// @ts-ignore
const MEASUREMENT_ID = import.meta.env.VITE_GA_ID;

export function Analytics() {
    const location = useLocation();

    // Load gtag once
    useEffect(() => {
        if (!MEASUREMENT_ID) {
            // @ts-ignore
            if (import.meta.env.DEV) {
                console.warn("GA4 measurement ID missing (VITE_GA4_ID / REACT_APP_GA4_ID).");
            }
            return;
        }
        if (window.gtag) return; // already loaded

        // 1) Load the GA4 script
        const s = document.createElement("script");
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
        document.head.appendChild(s);

        // 2) Init dataLayer + gtag
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
            // @ts-ignore
            window.dataLayer.push(arguments);
        };
        window.gtag("js", new Date());

        // Optional: basic Consent Mode (adjust to your policy/region)
        // window.gtag("consent", "default", {
        //   ad_user_data: "denied",
        //   ad_personalization: "denied",
        //   ad_storage: "denied",
        //   analytics_storage: "granted"
        // });

        // 3) Configure GA4
        window.gtag("config", MEASUREMENT_ID, {
            send_page_view: false // we’ll handle SPA page views manually
        });

        return () => {
            // (Usually you don’t remove GA when unmounting the app)
        };
    }, []);

    // Track page views on route change
    useEffect(() => {
        if (!MEASUREMENT_ID || !window.gtag) return;
        window.gtag("event", "page_view", {
            page_title: document.title,
            page_location: window.location.href,
            page_path: location.pathname + location.search
        });
    }, [location]);

    return null;
}
